import AppConstants from "../interfaces/AppConstants";

//todo move this to IoC container
let appConstsProvider: () => AppConstants = () => {
    return null;
}

export const registerAppConstantsProvider = (provider: () => AppConstants) => {
    //todo rebind over a IoC container instead
    appConstsProvider = provider;
}

export const getAppConsts = () => {
    return appConstsProvider();
}


// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/services/AppConstantsProvider.ts